import React from 'react';
import DestinationTemplate from '../../components/DestinationTemplate';

const NepalPage = () => {
  return <DestinationTemplate destinationId="nepal" />;
};

export default NepalPage;
